import { render } from "./RichTextEditor.vue?vue&type=template&id=1c0138f0&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=1c0138f0&scoped=true&lang=css"
import "./RichTextEditor.vue?vue&type=style&index=1&id=1c0138f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0138f0"]])

export default __exports__